module.exports = __webpack_public_path__ + "static/assets/7afbb18e5e9dbda1d22c680d205b0f88.svg";